// services/routingGuideDetailsService.js
import axiosInstance from "./AxiosInstance";

// Fetch routing guides
const fetchRoutingGuides = async () => {
  try {
    const response = await axiosInstance.get("/routing-guides");
    return response.data.data.map((guide) => ({
      ...guide,
      id: guide.routing_guide_id,
    }));
  } catch (error) {
    console.error("Failed to fetch routing guides:", error);
    throw error;
  }
};

const InitialfetchRoutingGuides = async (routing_guide_id) => {
  try {
    const response = await axiosInstance.get("/routing-guides?routing_guide_id="+`${routing_guide_id}`);
    return response.data
  } catch (error) {
    console.error("Failed to fetch routing guides:", error);
    throw error;
  }
};


const fetchRoutingGuideRecords = async (guideId, searchParams = {}) => {
  try {
    // Map frontend params to backend params
    const paramMapping = {
      consolidatorId: "consolidator",
      serviceLevel: "service_level",
      dcId: "dc",
      storeId: "store",
      carrierId: "carrier",
    };

    // Transform params to match backend expectations
    const transformedParams = Object.entries(searchParams).reduce(
      (acc, [key, value]) => {
        const backendKey = paramMapping[key] || key;
        if (value) acc[backendKey] = value;
        return acc;
      },
      {}
    );

    // Add routing guide ID to params
    transformedParams.routingGuideId = guideId;

    // Construct query string
    const queryString = Object.entries(transformedParams)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    const response = await axiosInstance.get(
      `/routing-guides/${guideId}/records?${queryString}`
    );

    if (response.data?.data) {
      return response.data.data.map((record) => ({
        ...record,
        id: record.record_id,
      }));
    }
    return [];
  } catch (error) {
    console.error("Failed to fetch routing guide records:", error);
    throw error;
  }
};

// Create new routing guide record
const createRoutingGuideRecord = async (guideId, recordData) => {
  console.log("recordData", recordData);
  try {
    const response = await axiosInstance.post(
      `/routing-guides/${guideId}/records`,
      recordData
    );
    return response.data;
  } catch (error) {
    console.error("Error creating routing guide record:", error);
    throw error;
  }
};

// Update routing guide record
const updateRoutingGuideRecord = async (guideId, recordId, recordData) => {
  console.log("recordData", recordData);
  const payload = {
    record_id: recordId,
    routing_guide_id: recordData.routing_guide_id,
    ship_from_zip1: recordData.ship_from_zip1,
    ship_from_zip2: recordData.ship_from_zip2,
    consolidator: recordData.consolidator,
    dc: recordData.dc,
    store: recordData.store_type,
    department: recordData.department_type === "list" ? recordData.department_list : recordData.department_type,
    unit_type: recordData.unit_type,
    u_min: recordData.u_min,
    u_max: recordData.u_max,
    wt_min: recordData.wt_min,
    wt_max: recordData.wt_max,
    ship_message: recordData.ship_message,
    service_level: recordData.service_level,
    carrier: recordData.carrier
  }
  console.log("payload", payload);
  
  try {
    const response = await axiosInstance.put(
      `/routing-guides/${guideId}/records/${recordId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error updating routing guide record:", error);
    throw error;
  }
};

// Delete routing guide record
const deleteRoutingGuideRecord = async (guideId, recordId) => {
  try {
    const response = await axiosInstance.delete(
      `/routing-guides/${guideId}/records/${recordId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting routing guide record:", error);
    throw error;
  }
};

// Update routing guide details
const updateRoutingGuide = async (guideId, guideData) => {
  try {
    const response = await axiosInstance.put(
      `/routing-guides/${guideId}`,
      guideData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating routing guide:", error);
    throw error;
  }
};

// Fetch facilities (consolidators, DCs)
const fetchFacilities = async () => {
  try {
    const response = await axiosInstance.get("/facility", {
      params: { pageSize: 100 },
    });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching facilities:", error);
    throw error;
  }
};

const bulkUploadRoutingGuideRecords = async (guideId, records) => {
  try {
    const response = await axiosInstance.post(
      `/routing-guides/records/${guideId}`,
      records
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading bulk records:", error);
    throw error;
  }
};

// Fetch carriers
const fetchCarriers = async () => {
  try {
    const response = await axiosInstance.get("/scac", {
      params: { pageSize: 100 },
    });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching carriers:", error);
    throw error;
  }
};

// Fetch service levels
const fetchServiceLevels = async () => {
  try {
    const response = await axiosInstance.get("/serviceLevel", {
      params: { pageSize: 100 },
    });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching service levels:", error);
    throw error;
  }
};

// Fetch stores
const fetchStores = async () => {
  try {
    const response = await axiosInstance.get("/store", {
      params: { pageSize: 100 },
    });
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching stores:", error);
    throw error;
  }
};

// Fetch commodity codes
const fetchCommodityCodes = async () => {
  try {
    const response = await axiosInstance.get("/commodityCode", {
      params: { pageSize: 100,sortBy: "commodity_code" },
    });
    if (response.data?.data && Array.isArray(response.data.data)) {
      return response.data.data;
    }
    throw new Error("Invalid commodity codes data structure");
  } catch (error) {
    console.error("Error fetching commodity codes:", error);
    throw error;
  }
};

export {
  bulkUploadRoutingGuideRecords,
  fetchRoutingGuides,
  fetchRoutingGuideRecords,
  createRoutingGuideRecord,
  updateRoutingGuideRecord,
  deleteRoutingGuideRecord,
  updateRoutingGuide,
  fetchFacilities,
  fetchCarriers,
  fetchServiceLevels,
  fetchStores,
  fetchCommodityCodes,
  InitialfetchRoutingGuides,
};
